RivalIQ.module('utils', function (utils, App, Backbone, Marionette, $, _) {

    'use strict';

    const tooltip = utils.tooltip = {};

    tooltip.addTooltip = function (obj, options) {
        if (!navigator.userAgent.match(/iPhone/i) && !navigator.userAgent.match(/iPad/i)) {
            obj.tooltip(options);
        }
    };

    // Adds a popover to the given el using mouse events. The popover will show when a mouse enters
    // el, and stays up if the mouse is over el or the popover.
    tooltip.addPopover = function (el, popover, options) {

        const placement = _.get(options, 'placement') || 'auto right';

        const showDelayMS = _.get(options, ['delay', 'show']) || 100;
        const hideDelayMS = _.get(options, ['delay', 'hide']) || 300;
        let showing = false;
        popover = (_.isFunction(popover) ? popover() : popover);
        if (_.isString(popover)) {
            popover = {
                content: popover
            };
        }
        el.popover({
            title: popover.title,
            content: popover.content,
            trigger: 'manual',
            container: 'body',
            placement: placement,
            html: true
        }).on('mouseenter', function (e) {
            const _this = this;

            $('.popover').not(_this).popover('hide');
            setTimeout(function () {

                // since showDelayMS might be a long-ish time, we need to make sure that it's still valid that this popover should show.
                if (!$('.popover:hover').length && !el.is(':hover')) {
                    return;
                }

                $(_this).popover('show');
                showing = true;
                $('.popover').on('mouseleave', function () {
                    if (showing && !el.is(':hover')) {
                        showing = false;
                        $(_this).popover('hide');
                    }
                });
                const onShown = _.get(options, 'onShown');
                if (onShown) {
                    onShown(e);
                }
            }, showDelayMS);
        }).on('mouseleave', function (e) {
            const _this = this;
            setTimeout(function () {
                if (showing && !el.is(':hover')) {
                    if (!$('.popover:hover').length) {
                        showing = false;
                        $(_this).popover('hide');
                    }
                }
            }, hideDelayMS);
        });
    };

});
